enum PaymentServiceTypeEnum {
    QUICKBOOKS_ONLINE_PAYMENTS = 1,
    SQUARE,
    STRIPE,
    AUTHORIZE_NET,
    PAYPAL,
    AMAZON,
}

export default PaymentServiceTypeEnum;
